// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const orgnr: CountryValidator<"NO"> = createValidator(
  "no.orgnr",
  139,
);

export default orgnr;
export const compact = orgnr.compact;
export const format = orgnr.format;
export const validate = orgnr.validate;
export const generate = (): string =>
  orgnr.generate?.() ??
  (() => {
    throw new Error(
      "Validator no.orgnr cannot generate values",
    );
  })();
